module.exports = " <div v-if=show class=showbanner _v-344a059c=\"\"> <p class=text-right _v-344a059c=\"\"> <a @click=close style=cursor:pointer _v-344a059c=\"\"><span class=\"glyphicon glyphicon-remove-circle\" _v-344a059c=\"\"></span></a> </p> <h3 _v-344a059c=\"\"><strong _v-344a059c=\"\">{{banner.Type}}</strong></h3> <p _v-344a059c=\"\"> {{banner.Description}} </p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-344a059c!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Common/banner.vue
// module id = 668
// module chunks = 0